import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface LatestUpdateProps {
  movies: Movie[];
}

export default function LatestUpdate({ movies }: LatestUpdateProps) {
  return (
    <section className="w-full px-4 md:px-6 py-10">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900">
              最新上线
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              刚刚更新的精彩内容
            </p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="space-y-3">
          {movies.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.slug}`}
              className="flex items-center gap-4 p-3 rounded-lg bg-background-50 hover:bg-background-100 transition-colors group cursor-pointer"
            >
              <span className="text-lg font-heading font-bold text-foreground-300 w-6 text-center">
                {String(index + 1).padStart(2, '0')}
              </span>
              <div className="w-12 h-16 rounded overflow-hidden flex-shrink-0">
                <img
                  src={movie.image}
                  alt={movie.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {movie.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">
                  {movie.description}
                </p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-secondary-100 text-secondary-700">
                  {movie.category}
                </span>
                <span className="text-xs text-foreground-500">{movie.year}</span>
              </div>
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className="ri-play-circle-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}